import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles, Theme } from '@material-ui/core';

type CustomIconProps = {
  fill: string;
  stroke?: string;
  fontSize: 'inherit' | 'medium' | 'default' | 'large' | 'small' | undefined;
  className?: string;
};

const useStyles = makeStyles((theme: Theme) => ({
  svgRoot: {
    width: '18px',
  },
}));

const FrameSourceIcon = ({
  fontSize,
  fill,
  stroke,
  className,
}: CustomIconProps) => {
  const classes = useStyles();
  return (
    <SvgIcon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      fontSize={fontSize}
      className={className}
      classes={{ root: classes.svgRoot }}
    >
      <path
        d="M4.825 9L6.3 10.475C6.48333 10.6583 6.575 10.8875 6.575 11.1625C6.575 11.4375 6.48333 11.675 6.3 11.875C6.1 12.075 5.8625 12.175 5.5875 12.175C5.3125 12.175 5.075 12.075 4.875 11.875L2.7 9.7C2.5 9.5 2.4 9.26667 2.4 9C2.4 8.73333 2.5 8.5 2.7 8.3L4.9 6.1C5.1 5.9 5.33333 5.80417 5.6 5.8125C5.86667 5.82083 6.1 5.925 6.3 6.125C6.48333 6.325 6.57917 6.55833 6.5875 6.825C6.59583 7.09167 6.5 7.325 6.3 7.525L4.825 9ZM13.175 9L11.7 7.525C11.5167 7.34167 11.425 7.1125 11.425 6.8375C11.425 6.5625 11.5167 6.325 11.7 6.125C11.9 5.925 12.1375 5.825 12.4125 5.825C12.6875 5.825 12.925 5.925 13.125 6.125L15.3 8.3C15.5 8.5 15.6 8.73333 15.6 9C15.6 9.26667 15.5 9.5 15.3 9.7L13.1 11.9C12.9 12.1 12.6667 12.1958 12.4 12.1875C12.1333 12.1792 11.9 12.075 11.7 11.875C11.5167 11.675 11.4208 11.4417 11.4125 11.175C11.4042 10.9083 11.5 10.675 11.7 10.475L13.175 9ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V13C0 12.7167 0.0958333 12.4792 0.2875 12.2875C0.479167 12.0958 0.716667 12 1 12C1.28333 12 1.52083 12.0958 1.7125 12.2875C1.90417 12.4792 2 12.7167 2 13V16H5C5.28333 16 5.52083 16.0958 5.7125 16.2875C5.90417 16.4792 6 16.7167 6 17C6 17.2833 5.90417 17.5208 5.7125 17.7125C5.52083 17.9042 5.28333 18 5 18H2ZM16 18H13C12.7167 18 12.4792 17.9042 12.2875 17.7125C12.0958 17.5208 12 17.2833 12 17C12 16.7167 12.0958 16.4792 12.2875 16.2875C12.4792 16.0958 12.7167 16 13 16H16V13C16 12.7167 16.0958 12.4792 16.2875 12.2875C16.4792 12.0958 16.7167 12 17 12C17.2833 12 17.5208 12.0958 17.7125 12.2875C17.9042 12.4792 18 12.7167 18 13V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18ZM0 5V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H5C5.28333 0 5.52083 0.0958333 5.7125 0.2875C5.90417 0.479167 6 0.716667 6 1C6 1.28333 5.90417 1.52083 5.7125 1.7125C5.52083 1.90417 5.28333 2 5 2H2V5C2 5.28333 1.90417 5.52083 1.7125 5.7125C1.52083 5.90417 1.28333 6 1 6C0.716667 6 0.479167 5.90417 0.2875 5.7125C0.0958333 5.52083 0 5.28333 0 5ZM16 5V2H13C12.7167 2 12.4792 1.90417 12.2875 1.7125C12.0958 1.52083 12 1.28333 12 1C12 0.716667 12.0958 0.479167 12.2875 0.2875C12.4792 0.0958333 12.7167 0 13 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V5C18 5.28333 17.9042 5.52083 17.7125 5.7125C17.5208 5.90417 17.2833 6 17 6C16.7167 6 16.4792 5.90417 16.2875 5.7125C16.0958 5.52083 16 5.28333 16 5Z"
        fill={fill}
      />
    </SvgIcon>
  );
};

export default FrameSourceIcon;
